var exports = {
  "Nr": "StreamWatchHoverCard.module__card___UDJqXz",
  "Br": "StreamWatchHoverCard.module__variantCompact___UDJqXz",
  "wy": "StreamWatchHoverCard.module__variantList___UDJqXz",
  "VH": "StreamWatchHoverCard.module__preview___UDJqXz",
  "sf": "StreamWatchHoverCard.module__previewCompact___UDJqXz",
  "$8": "StreamWatchHoverCard.module__previewList___UDJqXz",
  "oz": "StreamWatchHoverCard.module__previewImage___UDJqXz",
  "nZ": "StreamWatchHoverCard.module__previewFallback___UDJqXz",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___UDJqXz",
  "Iq": "StreamWatchHoverCard.module__compactButton___UDJqXz",
  "$l": "StreamWatchHoverCard.module__actionRow___UDJqXz",
  "uu": "StreamWatchHoverCard.module__actionButtons___UDJqXz",
  "jb": "StreamWatchHoverCard.module__listButton___UDJqXz",
  "fX": "StreamWatchHoverCard.module__previewClickable___UDJqXz",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___UDJqXz",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___UDJqXz",
  "z0": "StreamWatchHoverCard.module__protipRow___UDJqXz",
  "cm": "StreamWatchHoverCard.module__protipText___UDJqXz",
};

module.exports = exports;
